$(function () {
    $('#new-rep-modal').on('show.bs.modal', function (e) {
        var modal = $(this);
        var academicYear = $(modal).find('input[type="hidden"][name="academic-year"]');
        var programmeYear = $(modal).find('input[type="hidden"][name="programme-year"]');

        $(academicYear).val($('ul.academic-year-filter li.active').text().trim());
        $(programmeYear).val($('ul.programme-year-filter li.active').text().trim());
    });

    $('.delete-rep-btn').on('click', function () {
        var button       = $(this);
        var modal        = $('#delete-rep-modal');
        var id           = $(button).data('id');
        var userFullName = $(button).data('user-full-name');
        var idField      = $(modal).find('input[type="hidden"][name="id"]');
        var userNameText = $(modal).find('span.rep-name-txt');

        $(idField).val(id).change();
        $(userNameText).text(userFullName);
    });
});
